export interface ImageInterface {
  name: string,
  description?: string,
  alt_text?: string
}

export class Image {
  name: string;
  description?: string;
  altText?: string;

  constructor(
    opts: ImageInterface
  ) {
    this.name = opts.name;
    this.description = opts.description || '';
    this.altText = opts.alt_text || '';
  }

  toJson(): ImageInterface {
    return {
      "name": this.name,
      "description": this.description,
      "alt_text": this.altText
    }
  }

  equals(img: Image): boolean {
    return this.name === img.name &&
        this.description === img.description &&
        this.altText === img.altText;
  }
}